import * as yup from 'yup';

export const LoginSchema = yup.object().shape({
  email: yup.string().trim().email('Invalid email').required('Email is required field'),
  password: yup.string().trim().min(5, 'Invalid password').required('Password is required field'),
});
